import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  // BG-slugged paths for footer link targets (Footer is not language-aware today;
  // anchored to the BG routes). i18n-ignore: route slugs, not user-facing copy.
  const shopLinks = [
    { path: '/продукти', label: t('footer.links.products') }, // i18n-ignore: route slug
    { path: '/продукти', label: t('footer.links.categories') }, // i18n-ignore: route slug
    { path: '/проследяване', label: t('footer.links.tracking') }, // i18n-ignore: route slug
  ];

  const helpLinks = [
    { path: '/контакти', label: t('footer.links.contact') }, // i18n-ignore: route slug
    { path: '/политика-за-връщане', label: t('footer.links.returns') }, // i18n-ignore: route slug
  ];

  const legalLinks = [
    { path: '/общи-условия', label: t('footer.links.terms') }, // i18n-ignore: route slug
    { path: '/поверителност', label: t('footer.links.privacy') }, // i18n-ignore: route slug
    { path: '/бисквитки', label: t('footer.links.cookies') }, // i18n-ignore: route slug
    { path: '/политика-за-връщане', label: t('footer.links.refunds') }, // i18n-ignore: route slug
  ];

  const linkClass =
    'inline-flex items-center min-h-[44px] min-w-[44px] py-1 md:min-h-0 md:min-w-0 md:py-0 text-[14px] text-ink-2 hover:text-ink transition-colors';

  const headingClass =
    'text-[11px] uppercase tracking-[0.2em] text-ink-3 mb-4 pb-2 border-b border-rust/40 inline-block';

  return (
    <footer>
      {/* Top stripe — same on mobile and desktop */}
      <div className="bg-ink text-ivory text-[11px] uppercase tracking-[0.18em] py-3 text-center">
        <span className="text-ivory/80">{t('footer.familyAtelier')}</span>
        <span className="mx-2 text-ivory/40">·</span>
        <span className="text-ivory/80">{t('footer.location')}</span>
        <span className="mx-2 text-ivory/40">·</span>
        <a
          href="tel:+359894488936"
          className="inline-flex items-center justify-center min-h-[44px] md:min-h-0 px-2 md:px-0 text-ivory hover:text-gold transition-colors"
        >
          +359 89 448 8936
        </a>
      </div>

      {/* Mobile footer — slim band, < md only */}
      <div className="md:hidden bg-ivory text-ink px-4 py-3">
        <div className="flex items-center justify-between mb-2">
          <Link
            to="/"
            className="font-display text-[28px] leading-none text-ink"
          >
            Gul<span className="italic text-rust">Art</span>
          </Link>
          <div className="flex items-center gap-1">
            <a
              href="https://www.facebook.com/profile.php?id=100077700766434"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-11 h-11 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors touch-manipulation"
              aria-label="Facebook"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a
              href="viber://chat?number=%2B359894488936"
              className="inline-flex items-center justify-center w-11 h-11 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors touch-manipulation"
              aria-label="Viber"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.302 4.187.696 6.7.633 9.817c-.063 3.116-.139 8.978 5.522 10.58h.002l-.005 2.42s-.036 1 .622 1.197c.78.246 1.246-.512 1.998-1.317.4-.4.984-1.067 1.412-1.587 3.92.328 6.93-.42 7.282-.53.78-.246 5.193-.812 5.928-6.81.764-6.196-.382-10.087-2.448-11.836l-.002-.002c-.616-.546-3.155-2.418-8.81-2.44 0 0-.42-.025-1.234-.025zM11.515 1.929c4.83.023 7.34 1.262 7.85 1.71 1.747 1.46 2.638 5.041 1.992 10.223-.616 5.005-3.92 5.32-4.578 5.527-.28.087-2.589.66-5.911.453 0 0-2.483 2.988-3.256 3.762-.121.121-.255.17-.347.146-.13-.034-.169-.193-.169-.422l.014-4.022c-4.806-1.337-4.523-6.323-4.467-8.926.054-2.606.628-4.652 2.078-6.083 2.001-1.836 5.555-2.378 7.7-2.367zm.066 2.117c-.146 0-.272.109-.292.255-.018.145.072.252.218.252 1.583.011 2.91.532 3.964 1.554 1.054 1.022 1.583 2.391 1.602 4.098.019.143.108.252.252.252h.012c.144 0 .252-.126.252-.27-.018-1.85-.61-3.346-1.78-4.482-1.171-1.135-2.66-1.677-4.218-1.677h-.012zm-3.493.939c-.5.025-1 .25-1.345.622-.292.318-.463.731-.463 1.175l.001.05c.06.879.428 1.806 1.115 2.775a17.5 17.5 0 0 0 1.601 1.98 17.5 17.5 0 0 0 1.98 1.601c.969.687 1.896 1.054 2.775 1.115l.05.001c.444 0 .858-.171 1.175-.463.372-.345.597-.845.622-1.345.025-.5-.171-.946-.524-1.256l-1.296-1.143c-.345-.305-.84-.375-1.252-.181l-1.045.485c-.181-.086-.534-.294-.95-.71-.417-.416-.624-.769-.71-.95l.485-1.045c.194-.412.124-.907-.181-1.252L9.974 6.327c-.31-.353-.755-.55-1.255-.524z" />
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@user63245824000978?_r=1&_t=ZN-96O2ExPTLvj"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-11 h-11 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors touch-manipulation"
              aria-label="TikTok"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
              </svg>
            </a>
          </div>
        </div>

        <div className="flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-ink-2 mb-2">
          <Link
            to="/контакти" // i18n-ignore: route slug
            className="inline-flex min-h-[44px] items-center hover:text-ink transition-colors"
          >
            {t('footer.mobileLinks.contact')}
          </Link>
          <Link
            to="/общи-условия" // i18n-ignore: route slug
            className="inline-flex min-h-[44px] items-center hover:text-ink transition-colors"
          >
            {t('footer.mobileLinks.terms')}
          </Link>
          <Link
            to="/бисквитки" // i18n-ignore: route slug
            className="inline-flex min-h-[44px] items-center hover:text-ink transition-colors"
          >
            {t('footer.mobileLinks.cookies')}
          </Link>
          <Link
            to="/поверителност" // i18n-ignore: route slug
            className="inline-flex min-h-[44px] items-center hover:text-ink transition-colors"
          >
            {t('footer.mobileLinks.privacy')}
          </Link>
        </div>

        <p className="text-[11px] text-ink-3">
          © {currentYear} GulArt · {t('footer.copyrightLocation')}
        </p>
      </div>

      {/* Desktop footer — full 4-column grid, md+ only */}
      <div className="hidden md:block bg-ivory text-ink">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-4 gap-x-12">
            <div className="md:pr-4">
              <Link to="/" className="inline-block mb-3">
                <span className="font-display text-[40px] leading-none text-ink">
                  Gul<span className="italic text-rust">Art</span>
                </span>
              </Link>
              <p className="text-[13px] text-ink-2 leading-relaxed">
                {t('footer.addressFull')}
              </p>
            </div>

            <div>
              <h4 className={headingClass}>{t('footer.headingShop')}</h4>
              <ul className="space-y-2">
                {shopLinks.map((link, i) => (
                  <li key={`shop-${i}`}>
                    <Link to={link.path} className={linkClass}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className={headingClass}>{t('footer.headingHelp')}</h4>
              <ul className="space-y-2">
                {helpLinks.map((link, i) => (
                  <li key={`help-${i}`}>
                    <Link to={link.path} className={linkClass}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className={headingClass}>{t('footer.headingLegal')}</h4>
              <ul className="space-y-2">
                {legalLinks.map((link, i) => (
                  <li key={`legal-${i}`}>
                    <Link to={link.path} className={linkClass}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-line/50 flex items-center justify-between gap-4">
            <p className="text-[12px] text-ink-3">
              © {currentYear} GulArt. {t('footer.rights')}
            </p>
            <div className="flex items-center gap-1">
              <a
                href="https://www.facebook.com/profile.php?id=100077700766434"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-9 h-9 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors"
                aria-label="Facebook"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://wa.me/359894488936"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-9 h-9 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors"
                aria-label="WhatsApp"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@user63245824000978?_r=1&_t=ZN-96O2ExPTLvj"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-9 h-9 rounded-full text-ink-2 hover:bg-ivory-2 transition-colors"
                aria-label="TikTok"
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
